import { Box, styled } from '@mui/material';

import { ActionBar } from '@/components/Layout/Layout.styled';

export const ReviewPersonalDetailsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
  paddingBottom: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    paddingBottom: 0,
  },
}));

export const ReviewActionBar = styled(ActionBar)(({ theme }) => ({
  flexWrap: 'wrap',
  '.MuiButton-root': {
    minWidth: '100%',
  },
  [theme.breakpoints.up('lg')]: {
    flexWrap: 'nowrap',
    '.MuiButton-root': {
      minWidth: 'auto',
    },
  },
}));
